import logo from "./logo.svg";
import "./App.css";
import Timetable from "./components/TimeTable";

function App() {
  return (
    <div className="App">
      <Timetable />
    </div>
  );
}

export default App;
